import { sendGet } from "./axios";

export const getListRevenue = (typeSearch, params) => sendGet(`/revenue/${typeSearch}`, params);

export const getOrderForOutsourcing = (params) => sendGet(`/revenue/outsourcing-orders`, params);
export const getCountOrderByArea = (params) => sendGet(`/revenue/outsourcing-areas`, params);
export const getCountOrderByTherapist = (params) => sendGet(`/revenue/outsourcing-therapists`, params);
